import { IMAGE_UPLOADER } from '../../config';
import Auth from '../../services/auth';

export const config = {
  url: IMAGE_UPLOADER,
  acceptFormats: 'image/jpeg, image/png'
};

const send = (file) => {
  const formData = new FormData();
  formData.append('photo', file);
  const apiToken = (Auth.getUserInfo() || {}).api_token;

  return fetch(config.url, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${apiToken}`
    },
    body: formData
  });
};

export const postFiles = (files, cb) => {
  const index = 0;
  const result = [];
  const postFile = (next) => {
    if (next === files.length) {
      cb();
    } else {
      const req = send(files[next]);

      req
        .then((res) => {
          return res.json();
        })
        .then(() => {
          console.log("Success: ", next);
          result.push(true);
          return postFile(next + 1);
        })
        .catch(() => {
          console.log("Error: ", next);
          result.push(false);
          return postFile(next + 1);
        });
    }
  };
  postFile(index)
};



// WEBPACK FOOTER //
// ./src/components/ImageUploader/api.js